module.exports = __webpack_public_path__ + "static/billy-ohio-d2510058bcc8d5b0eceef52c8591263b.otf";